import 'core-js';
import $ from 'jquery';
import select2 from 'select2';
import './_components';
import { FloatingChat } from './FloatingChat';

$(function () {
    $('.redirect-dropdown').on('change', (e) => {
        const url = $(e.target).val();
        if (url) {
            window.location = url;
        }
    });

    // Remove scroll listener from map
    if ($('.wpgmza_map').length) {
        const whenMapDefined = () => {
            window.setTimeout(function () {
                if (WPGMZA.maps[0] && WPGMZA.maps[0].olMap) {
                    delete WPGMZA.maps[0].olMap.listeners_['wheel'];
                } else {
                    whenMapDefined();
                }
            }, 50);
        };
        whenMapDefined();
    }

    const gformWrapper = $('.gform_wrapper');

    // restrict any future dates in card application Date of Birth Field

    // need to fix this throwing an error on all pages except for gravity forms pages
    if (gformWrapper.length > 0) {
        gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
            // Apply to card application form datepicker fields only
            if (formId == 7 && fieldId == 11) {
                optionsObj.maxDate = 0;
            }

            return optionsObj;
        });
    }

    FloatingChat();
});
